import React, { useState } from "react";
import ParticleBackground from "./ParticleBackground";
import "./DigitalPunjab.css";

const DigitalPunjab = () => {
  const [selectedVideo, setSelectedVideo] = useState(0);

  const videos = [
    {
      id: "ZtQAQGyUxkQ",
      title: "Hunarmand Punjab Video 1",
      thumbnail: `https://img.youtube.com/vi/ZtQAQGyUxkQ/mqdefault.jpg`,
    },
    {
      id: "As5DtBHLlDY",
      title: "Hunarmand Punjab Video 2",
      thumbnail: `https://img.youtube.com/vi/As5DtBHLlDY/mqdefault.jpg`,
    },
    {
      id: "9AnOeOdlG1c",
      title: "Hunarmand Punjab Video 3",
      thumbnail: `https://img.youtube.com/vi/9AnOeOdlG1c/mqdefault.jpg`,
    },
    // {
    //   id: "Ss0cuzczCMM",
    //   title: "Hunarmand Punjab Video 4",
    //   thumbnail: `https://img.youtube.com/vi/Ss0cuzczCMM/mqdefault.jpg`,
    // },
    {
      id: "C1PEgg0x2iE",
      title: "Hunarmand Punjab Video 6",
      thumbnail: `https://img.youtube.com/vi/C1PEgg0x2iE/mqdefault.jpg`,
    },

    // {
    //   id: "Prb2SI-2wtQ",
    //   title: "Hunarmand Punjab Video 10 (Upcoming)",
    //   thumbnail: `https://img.youtube.com/vi/Prb2SI-2wtQ/mqdefault.jpg`,
    // },
    // {
    //   id: "49Xr-WHgGGA",
    //   title: "Hunarmand Punjab Video 11",
    //   thumbnail: `https://img.youtube.com/vi/49Xr-WHgGGA/mqdefault.jpg`,
    // },
    // {
    //   id: "MwaXTW0_jc8",
    //   title: "Hunarmand Punjab Video 12",
    //   thumbnail: `https://img.youtube.com/vi/MwaXTW0_jc8/mqdefault.jpg`,
    // },
    {
      id: "MxI2z5t-48A",
      title: "Hunarmand Punjab Video 13",
      thumbnail: `https://img.youtube.com/vi/MxI2z5t-48A/mqdefault.jpg`,
    },
    {
      id: "JLPx3ZeM9Xc",
      title: "Hunarmand Punjab Video 14",
      thumbnail: `https://img.youtube.com/vi/JLPx3ZeM9Xc/mqdefault.jpg`,
    },
    {
      id: "Ckw7uIF5Jfw",
      title: "Hunarmand Punjab Video 15",
      thumbnail: `https://img.youtube.com/vi/Ckw7uIF5Jfw/mqdefault.jpg`,
    },
    {
      id: "r01oaRfkQ1Y",
      title: "Hunarmand Punjab Video 16",
      thumbnail: `https://img.youtube.com/vi/r01oaRfkQ1Y/mqdefault.jpg`,
    },
    {
      id: "AjUq1s8UrOY",
      title: "Hunarmand Punjab Video 17",
      thumbnail: `https://img.youtube.com/vi/AjUq1s8UrOY/mqdefault.jpg`,
    },
    {
      id: "spU3lJ_SqMk",
      title: "Hunarmand Punjab Video 18",
      thumbnail: `https://img.youtube.com/vi/spU3lJ_SqMk/mqdefault.jpg`,
    },

    // {
    //   id: "9dgJMrVYouo",
    //   title: "Hunarmand Punjab Video 5",
    //   thumbnail: `https://img.youtube.com/vi/9dgJMrVYouo/mqdefault.jpg`,
    // },
    // {
    //   id: "_3hRDF_FQqQ",
    //   title: "Hunarmand Punjab Video 7",
    //   thumbnail: `https://img.youtube.com/vi/_3hRDF_FQqQ/mqdefault.jpg`,
    // },
    // {
    //   id: "N5OYV3PkDXo",
    //   title: "Hunarmand Punjab Video 8",
    //   thumbnail: `https://img.youtube.com/vi/N5OYV3PkDXo/mqdefault.jpg`,
    // },
    // {
    //   id: "eisQK3Nv03g",
    //   title: "Hunarmand Punjab Video 9",
    //   thumbnail: `https://img.youtube.com/vi/eisQK3Nv03g/mqdefault.jpg`,
    // },
  ];

  const handleVideoSelect = (index) => {
    setSelectedVideo(index);
  };

  return (
    <>
      <div className="digital-punjab container mt-5">
        <div className="digital breadcrums">
          <ParticleBackground />
          <div className="px-lg-5 px-3">
            <p className="white bg-black font-14 d-p">Hunarmand Punjab</p>
            {/* <h2 className='white font-32'>Minister of Education, Punjab</h2> */}
            {/* <h2 className="white font-32">
              Minister of School & Higher Education, Punjab
            </h2> */}
            <p className="white font-16 d-content">
              <span className="fw-bold">Hunarmand Punjab</span> is an
              independent initiative aimed at equipping Pakistan’s youth with
              future-ready IT and digital skills through industry-focused
              training programs. With the appreciation and support extended
              during its launch by Honourable Minister for School & Higher
              Education, Punjab,{" "}
              <span className="fw-bold">Rana Sikandar Hayat</span>, our vision
              is to empower young people with practical digital expertise,
              enabling them to build sustainable careers, generate online
              income, and contribute to Pakistan’s digital economy. We are
              committed to creating a skilled, innovative, and globally
              competitive workforce for a brighter future.
            </p>
            {/* <p className='white font-16 d-content'>Rana Sikandar Hayat, Provincial Minister of School Education for Punjab, emphasized the importance of enhancing educational infrastructure and digital literacy across the province. He noted that while Punjab has made significant strides in improving educational outcomes, there remains a pressing need to integrate technology into the curriculum to prepare students for the modern workforce.</p> */}
          </div>
        </div>

        <div className="video-slider-container vid-wrapper">
          <div className="main-video-section">
            <div className="main-video-wrapper vid-container">
              <iframe
                src={`https://www.youtube.com/embed/${videos[selectedVideo].id}?autoplay=1`}
                title={videos[selectedVideo].title}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="video-playlist-section">
            <h4 className="playlist-title mb-3">Video Playlist</h4>
            <div className="video-playlist">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className={`video-thumbnail ${
                    selectedVideo === index ? "active" : ""
                  }`}
                  onClick={() => handleVideoSelect(index)}
                >
                  <div className="thumbnail-image">
                    <img src={video.thumbnail} alt={video.title} />
                    <div className="play-overlay">
                      <div className="play-button">▶</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalPunjab;
